import CreateAdminRoleDialogComponent from "./createAdminRoleDialog.component";

export default function CreateAdminRoleDialogContainer({
  open,
  handleClose,
  handleSubmit,
}) {
  return (
    <CreateAdminRoleDialogComponent
      open={open}
      handleClose={handleClose}
      handleSubmit={handleSubmit}
    />
  );
}
